import { Injectable } from '@angular/core'
import { CommonService } from '../../shared/services/common.service'
@Injectable({
  providedIn: 'root',
})
export class ContactusService {
  constructor(public commonService: CommonService) {}
  getcontacts(userType = 'current', allInfo = false) {
    const urlParams = ['users', userType]
    if (userType === 'anonymous') {
      urlParams.push('contactUsAnonymousUser')
    } else {
      if (allInfo) {
        urlParams.push('contactus?isAllInfo=true')
      } else {
        urlParams.push('contactus')
      }
    }
    let apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }

  getChannelPartners(userId) {
    const urlParams = ['users', userId, 'contactUsChannelPartners']
    let apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }

  isChannelPartners(userId) {
    const urlParams = ['users', userId, 'isChannelPartner']
    let apiUrl = this.commonService.constructUrl(urlParams)
    return this.commonService.getData(apiUrl)
  }
}
